import React, { useState, useEffect, useMemo } from 'react';
import uuid from 'uuid/v4';
import _ from 'lodash';
import FirstHeaderColumn from './FirstHeaderColumn';
import CrosstabMainColumnHeader from './CrosstabMainColumnHeader';
import CrosstabViewCellContent from './CrosstabViewCellContent';
import { setHeightOfColumns } from '../../../util/CrosstabUtils';

import CrosstabViewRowHeaders from './CrosstabViewRowHeaders';

let rowEndIndex = 100;
let colEndIndex = 100;

function CrosstabView({ tableData, handleCrosstabSaveButton, highlightRadioButton, cellElementList,
  onSort, handleHighlightShowButton, placeholder, warningText, toggleCheckVal, crosstabWeightTypes, 
  singleDeleteOperation, updateCrosstabGridTitleHeader, updateGridData, restoreGridTitle, handleCrosstabEdit, 
  crosstabFootNotes, getGridRows, saveGridTitle, editExpression, handleProbabilitiesEditClick, sortClickToggle,
  partsToShow }) {

    const [scrollStarted, setScrollStarted] = useState(0);
    const [columnHeaderList, setColumnHeaderList] = useState(tableData && tableData.columnHeaderList ? 
      tableData.columnHeaderList.slice(0, 100) : []);
    const [gridRows, setGridRows] = useState(getGridRows && getGridRows.length > 0 ? getGridRows.slice(0, 100) : []);
    const [totalColumnHeaderList, setTotalColumnHeaderList] = useState(tableData && tableData.columnHeaderList 
      ? tableData.columnHeaderList : []);

    const [totalGridRowsList, setTotalGridRowsList] = useState(getGridRows || []);
    
    const [updatedTitleIndex, setUpdatedTitleIndex] =  useState(null);
    const [updatedTitleGridType, setUpdatedTitleGridType] = useState(null);


    const handleScrollBarWidth = () => {
      $.fn.hasHScrollBar = () => {
        return $('#main-content-grid').get(0).scrollWidth > $('#main-content-grid').width();
      };
      $.fn.hasVScrollBar = () => {
        return $('#main-content-grid').get(0).scrollHeight > $('#main-content-grid').height();
      };
      $.fn.getScrollWidth = () => {
        const $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body');
        const widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
        $outer.remove();
        return 100 - widthWithScroll;
      };
      const isHScrollBar = $('#main-content-grid').hasHScrollBar();
      if (isHScrollBar) {
        const scrollWidth = $().getScrollWidth();
        if ($('.empty-crosstab-last-row').length === 0) {
          $('.crosstabViewerGrid-main').append(
              `<div class="empty-crosstab-last-row" style="height:${scrollWidth}px;line-height:
              ${scrollWidth}px"></div>`);
        }
      }
      if (!isHScrollBar) {
        if ($('.empty-crosstab-last-row').length !== 0) {
          $('.empty-crosstab-last-row').remove();
        }
      }
      const hasScrollBar = $('#main-content-grid').hasVScrollBar();
      if (hasScrollBar) {
        const scrollWidth = $().getScrollWidth();
        const height = $('#top-header-column .c-table-crosstab-col:first').height();
        if ($('.empty-table-crosstab-header-col').length === 0) {
          $('.c-table-crosstab-header .c-table-crosstab-row').append(
              `<span class="c-table-crosstab-col empty-table-crosstab-header-col" 
              style="min-width:${scrollWidth}px;width:${scrollWidth}px;height:${height}px"></span>`);
        }
      } else if ($('.empty-table-crosstab-header-col').length !== 0) {
        $('.empty-table-crosstab-header-col').remove();
      }
    }

    const virtualizedGridData = (target) => {
      const originalRowRecords = getGridRows;
      const scrollTop = target.scrollTop;
      const scrollLeft = target.scrollLeft;
      const scrollHeight = target.scrollHeight;
      const averageRowHeight = scrollHeight/rowEndIndex;
      let averageColWidth = $('#top-header-column .c-table--col:first').width();
  
      // when scroll is coming down
      if(scrollTop >= (rowEndIndex * averageRowHeight * 0.95) && originalRowRecords.length > rowEndIndex) {
        rowEndIndex = rowEndIndex + 50 > originalRowRecords.length ?
        originalRowRecords.length : rowEndIndex + 50;
        setGridRows(originalRowRecords.slice(0, rowEndIndex));
      }
      
      averageColWidth = averageColWidth !== undefined && !isNaN(averageColWidth) ? averageColWidth : 200;
      
      // When scroll is on right side
      if(scrollLeft >= (colEndIndex * averageColWidth * 0.95)  && totalColumnHeaderList.length > colEndIndex) {
        colEndIndex = colEndIndex + 50 > totalColumnHeaderList.length ?
        totalColumnHeaderList.length : colEndIndex + 50;
        setColumnHeaderList(totalColumnHeaderList.slice(0, colEndIndex));
      }
    }
    
    const updateGridTitle = (updatedTitleIndex, updatedTitleGridType) => {
      setUpdatedTitleIndex(updatedTitleIndex);
      setUpdatedTitleGridType(updatedTitleGridType);
    };
  
    const resetSelectedIndex = () => {
      setUpdatedTitleIndex(null);
      setUpdatedTitleGridType(null);
    };
      
    const handleSortingOfGrid = () => {
      setTimeout(() => {
        $('#top-header-column').scrollLeft($('#main-content-grid').scrollLeft());
      }, 100);
    }
  
    const renderColumnHeader = () => { return useMemo(() => 
      columnHeaderList.map((item, index) => (
        <CrosstabMainColumnHeader
          key={uuid()}
          columnHeight={
            setHeightOfColumns(partsToShow, columnHeaderList, toggleCheckVal, 'Crosstab-Column')
          }
          header={item}
          cellElementList={cellElementList}
          cellIndex={index}
          scrollStarted={scrollStarted}
          toggleCheckVal={toggleCheckVal}
          singleDeleteOperation={singleDeleteOperation}
          updateCrosstabGridTitleHeader={updateCrosstabGridTitleHeader}
          updateGridData={updateGridData}
          updateGridTitle={updateGridTitle}
          updatedTitleIndex={updatedTitleIndex}
          updatedTitleGridType={updatedTitleGridType}
          resetSelectedIndex={resetSelectedIndex}
          restoreGridTitle={restoreGridTitle}
          handleCrosstabEdit={handleCrosstabEdit}
          handleSortingOfGrid={handleSortingOfGrid}
          onSort={onSort}
          showFootNoteIcon={item.footnotes ? item.footnotes : []}
          crosstabFootNotes={crosstabFootNotes}
          partsToShow={partsToShow}
        />
      )), [columnHeaderList, toggleCheckVal.column, cellElementList, tableData.sortOrder, tableData.sortKey,
        tableData.sortColumnIndex, scrollStarted, updatedTitleIndex, updatedTitleGridType, sortClickToggle,
        crosstabFootNotes, editExpression, partsToShow]);
    };

    const saveTextChange = text => {
      saveGridTitle(text, 'Crosstab-View');
    }
  
    const handleContentScroll = e => {
      $('#top-header-column').scrollLeft(e.target.scrollLeft);
      $('#left-menu-content').scrollTop(e.target.scrollTop);
      
      virtualizedGridData(e.target);
      handleScrollBarWidth();
    }

    const renderRowHeaders = () => { return useMemo(() => (
      <CrosstabViewRowHeaders 
        cellElementList={cellElementList}
        getGridRows={gridRows}
        toggleCheckVal={toggleCheckVal}
        updateGridData={updateGridData}
        handleCrosstabEdit={handleCrosstabEdit}
        restoreGridTitle={restoreGridTitle}
        singleDeleteOperation={singleDeleteOperation}
        updateCrosstabGridTitleHeader={updateCrosstabGridTitleHeader}
        crosstabFootNotes={crosstabFootNotes}
        crosstabWeightTypes={crosstabWeightTypes}
        updatedTitleIndex={updatedTitleIndex}
        updateGridTitle={updateGridTitle}
        updatedTitleGridType={updatedTitleGridType}
        resetSelectedIndex={resetSelectedIndex}
        editExpression={editExpression}
        partsToShow={partsToShow}

      />), [cellElementList, gridRows, toggleCheckVal.row, crosstabFootNotes,
      crosstabWeightTypes, updatedTitleIndex, updatedTitleGridType, editExpression,
      partsToShow]);
    }

    const renderCellHeaders = () => { return useMemo(() => (
      <CrosstabViewCellContent
        cellElementList={cellElementList}
        getGridRows={gridRows}
        colEndIndex={colEndIndex}
        highlightAndFilter={tableData.highlightAndFilter}
        toggleCheckVal={toggleCheckVal}
        handleProbabilitiesEditClick={handleProbabilitiesEditClick}
        partsToShow={partsToShow}
      />), [cellElementList, gridRows, colEndIndex, tableData.highlightAndFilter, toggleCheckVal.row, partsToShow]);
    }

    const renderFirstHeaderColumn = () => { return useMemo(() => (
      <FirstHeaderColumn
        handleCrosstabSaveButton={handleCrosstabSaveButton}
        highlightRadioButton={highlightRadioButton}
        onValueChange={saveTextChange}
        handleHighlightShowButton={handleHighlightShowButton}
        tableData={tableData}
        showSave
        placeholder={placeholder}
        warningText={warningText}
        columnHeight={setHeightOfColumns(partsToShow, columnHeaderList, toggleCheckVal, 'Crosstab-First-Column')}
      />), [toggleCheckVal.column, columnHeaderList]);
    }


    useEffect(() => {
      setTimeout(() => {
        handleScrollBarWidth();
      }, 2000);
      window.addEventListener('resize', handleScrollBarWidth);
      saveGridTitle('', 'Crosstab-View');
      rowEndIndex = 100;
      colEndIndex = 100;

      return () => {
        window.removeEventListener('resize', handleScrollBarWidth);
        saveGridTitle('', 'Crosstab-View');
        rowEndIndex = 100;
        colEndIndex = 100;
      }
    }, []);

    useEffect(() => {
      if(!_.isEqual(totalColumnHeaderList, tableData.columnHeaderList)) {
        setColumnHeaderList(tableData.columnHeaderList.slice(0, colEndIndex));
        setTotalColumnHeaderList(tableData.columnHeaderList);
      }
    }, [tableData.columnHeaderList]);

    useEffect(() => {
      if(!_.isEqual(totalGridRowsList, getGridRows)) {
        setGridRows(getGridRows.slice(0, rowEndIndex));
        setTotalGridRowsList(getGridRows);
      }
    }, [getGridRows]);

    useEffect(() => {
      handleScrollBarWidth()
    }, [tableData.crosstabPerStudy]);


    if ($('.empty-crosstab-last-row').length !== 0) {
      $('.empty-crosstab-last-row').remove();
    }
    if ($('.empty-table-crosstab-header-col').length !== 0) {
      $('.empty-table-crosstab-header-col').remove();
    }
    
    if (columnHeaderList && gridRows) {
      return (<div>
        <div className="row expanded main-table">
          {renderFirstHeaderColumn()}
          <div id="top-header-column" className="column right-column-width c-table-container">
            <div className="c-table">
              <div className="c-table-crosstab-header">
                <div className="c-table-crosstab-row">
                  {renderColumnHeader()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row expanded main-content-grid">
          <div className="column left-column-width main-content-grid-left" id="left-menu-content">
            <div className="crosstabViewerGrid unstriped">
              <div className="crosstabViewerGrid-main">
                {renderRowHeaders()}
              </div>
            </div>
          </div>
          <div id="main-content-grid" className="column right-column-width main-content-grid-right" 
          onScroll={e => handleContentScroll(e)}>
            {renderCellHeaders()}
          </div>
        </div>
      </div>);
    }
    return '';
  };

export default React.memo(CrosstabView);